var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from 'react';
import styled from 'styled-components';
import { STACK_ALIGN, STACK_GAP, StackView } from "../StackView";
import { SIZE_M, SPACING_M } from "../helpers";
import { View, VIEW_BG_VIEW } from "../View";
import { Text, TEXT_SIZE } from "../Text";
var FillCircle = styled(View)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    width: ", ";\n    height: ", ";\n    border-radius: 50%;\n"], ["\n    width: ", ";\n    height: ", ";\n    border-radius: 50%;\n"])), SIZE_M, SIZE_M);
var Wrapper = styled(StackView)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    margin-top: -", ";\n"], ["\n    margin-top: -", ";\n"])), SPACING_M);
export var createSchedulingMatrixLegendFooter = function (_a) {
    var texts = _a.texts;
    return ({
        render: function () { return (React.createElement(Wrapper, { gap: STACK_GAP.m, align: STACK_ALIGN.center },
            (texts === null || texts === void 0 ? void 0 : texts.label) && React.createElement(Text, { size: TEXT_SIZE.s }, texts === null || texts === void 0 ? void 0 : texts.label),
            React.createElement(StackView, { gap: STACK_GAP.s, align: STACK_ALIGN.center },
                React.createElement(FillCircle, { backgroundView: VIEW_BG_VIEW.highlightDark }),
                React.createElement(Text, { size: TEXT_SIZE.s }, (texts === null || texts === void 0 ? void 0 : texts.selectMode) || 'Permitted')),
            React.createElement(StackView, { gap: STACK_GAP.s, align: STACK_ALIGN.center },
                React.createElement(FillCircle, { backgroundView: VIEW_BG_VIEW.highlightDarkInverted }),
                React.createElement(Text, { size: TEXT_SIZE.s }, (texts === null || texts === void 0 ? void 0 : texts.unselectMode) || 'Denied')))); }
    });
};
var templateObject_1, templateObject_2;
//# sourceMappingURL=legendFooter.js.map